<template v-cloak>
  <tbody>
    <template v-if="data && data.length">
      <template v-for="item in data">
        <tr v-bind:key="item.id">
          <td v-if="shouldRenderSelection">
            <multi-select :selection="selection" :row="item" />
          </td>

          <td v-for="(col, index) in columns" :class="col.tdClass" :style="col.tdStyle"
              @click="!col.isIconTrueFalse ? null : callAction(col.iconAction, item)" :key="index">
            <!-- <td> component (tdComp) -->
            <component
              v-if="col.tdComp"
              :is="forDynCompIs(col.tdComp)"
              :row="item"
              :field="col.field"
              :value="item[col.field]"
              :nested="item.__nested__"
              :link="col.link"
              :icon="!col.isIconTrueFalse ? col.icon : getStatusIcon(item[col.field])"
              :isCurrency="col.isCurrency"
              :properties="prepParams(item, col.paramProperties)"
              :propertyStatic="col.propertyStatic"
              :propertyValue="item[col.property]"
              v-bind="$props"
            >
            </component>

            <template v-else>
              <span
                v-if="!col.booleanActif && !col.booleanYesNo && !col.arrayTab"
                >{{ !col.isCurrency ? item[col.field] :  formatCurrency(item[col.field]) }}</span
              >

              <span v-if="col.booleanActif">
                <span v-if="!item[col.field]" class="badge badge-success">{{
                  $t('Utilities.active')
                }}</span>
                <span v-if="item[col.field]" class="badge badge-warning">{{
                  $t('Utilities.inactive')
                }}</span>
              </span>

              <span v-if="col.booleanYesNo">
                <span v-if="!item[col.field]" class="badge badge-success"
                  >Oui</span
                >
                <span v-if="item[col.field]" class="badge badge-danger"
                  >Non</span
                >
              </span>

              <span v-if="col.arrayTab">
                <span v-for="role in item[col.field]"
                  >[{{ $t(col.traductionPath + '.' + role.toLowerCase()) }}]
                </span>
              </span>
            </template>
          </td>
        </tr>
        <transition name="fade">
          <tr v-if="item.__nested__ && item.__nested__.visible">
            <td :colspan="colLen">
              <!-- nested component -->
              <component
                :is="forDynCompIs(item.__nested__.comp)"
                :row="item"
                :nested="item.__nested__"
                v-bind="$props"
              >
              </component>
            </td>
          </tr>
        </transition>
      </template>
    </template>
    <tr v-else-if="!leftFixed && !rightFixed">
      <td :colspan="colLen" class="text-center text-muted">
        ( {{ $i18nForDatatable('No Data') }} )
      </td>
    </tr>
  </tbody>
</template>
<script>
import MultiSelect from './MultiSelect.vue';
import props from '../_mixins/props';
import shouldRenderSelection from '../_mixins/shouldRenderSelection';

export default {
  name: 'TableBody',
  components: { MultiSelect },
  mixins: [props, shouldRenderSelection],
  computed: {
    colLen() {
      return this.columns.length + !!this.selection;
    },
  },
  methods: {
    formatCurrency(val){
      if(!val) return "0.00 $"
      return val.toFixed(2) + " $"
    },
    //Return icon for true/false value
    getStatusIcon(value){
      return value ? "fa fa-check-square-o iconGreen" : "fa fa-exclamation-triangle iconRed"
    },
    callAction(action, item){
      action(item.id);
    }
  }
};
</script>

<style>
  .iconGreen {
    color: green !important;
    font-size: 23px;
    cursor: initial !important;

  }
  .iconRed {
    color: red !important;
    font-size: 23px;
}

</style>



// WEBPACK FOOTER //
// src/_utilities/vue2-datatable/Table/TableBody.vue